export default __webpack_public_path__ + "static/media/chisom.3133cfe4.webp";